import React from 'react';
import classNames from 'classnames';
import {Icon} from '../icon/icon';
import Image, {IImageProps} from '../image/image';
import {IPageSelectProps} from '../../modules';
import {Select} from '../forms';

export interface IUserProps {
    title: string;
    className?: string;
    color?: string;
    image?: IImageProps;
    businessUnitName?: string;
    isAdminOrManager?: string;
    subtitle?: string;
    managedBusinessUnits?: IPageSelectProps;
}

const User = (props: IUserProps): JSX.Element => {

    const className: string = classNames(
        'user',
        props.className,
    );

    const renderBlobOrImage: () => JSX.Element = (): JSX.Element => {
        if (props.image) {
            return <Image {...props.image} className="user__image"/>;
        } else {
            return (
                <div className="user__blob" style={{background: props.color}}>
                    <Icon className="user__icon" name="user"/>
                </div>
            );
        }
    };

    const renderContent = (): JSX.Element => (
        <div className="user__content">
            {renderBlobOrImage()}
            <div>
                <div className="user__text">
                    <span className="user__title">
                        {props.title}
                        {props.isAdminOrManager && (
                            <span> ({props.isAdminOrManager})</span>
                        )}
                    </span>
                    {props.businessUnitName && (
                        <span className="user__sub-title">{props.businessUnitName} </span>
                    )}
                </div>
                {props.managedBusinessUnits && (
                    <div className="user__business-units">
                        <Select {...props.managedBusinessUnits} style={'borderless'} className="select--readonly" readonlyOptions={true} />
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className={className}>
            {renderContent()
            }
        </div>
    );
};

export default User;
